// apiConfig.js
const API_CONFIG = {
  apiUrl: 'https://app.bisenter-rdc.com/',
  };
  
  export default API_CONFIG;
 